import 'babel-polyfill';
import React from 'react';
import ReactDOM from 'react-dom';
import { Router, Route, browserHistory } from 'react-router'
import {createStore, applyMiddleware, compose } from 'redux'
import {Provider} from 'react-redux';
import { syncHistoryWithStore, routerReducer, routerMiddleware } from 'react-router-redux';
import thunkMiddleware from 'redux-thunk';
import LogRocket from 'logrocket';
import crashReporter from './middlewares/crashReporter';
import {getStateFromStorage, setStateInStorge} from './common/storage';
import reducers from './reducers';
import {initializeGoogleAnalytics} from './common/analytics';
import {trackGAPageView} from './actions/common/gaActions';
import HomeScreen from './containers/common/HomeScreen';
import {URLs} from "./common/constants";

const useLogRocket = Farmigo.serverData.isProduction && Farmigo.serverData.customerTier === 'A';
if (useLogRocket) {
    LogRocket.init('farmigo/farms-new-ui', {shouldShowReportingButton:false, uploadTimeInterval:10000, network:{
        requestSanitizer: function (request){
            if ((request.url.indexOf("AuthenticationService")!==-1)||(request.url.indexOf("MembersService")!==-1)||(request.url.indexOf("updateMember")!==-1)||(request.url.indexOf("ACH")!==-1)||(request.url.indexOf("Echeck")!==-1)){
                request.body=null;
            }
            return request;}
        }});
    if (typeof Raven !== 'undefined')
        Raven.setDataCallback((data) => {data.extra.sessionURL = LogRocket.sessionURL;return data;});
}
//Initi GA with farm tracking ID
initializeGoogleAnalytics(Farmigo.serverData.farmGATrackingID, Farmigo.serverData.farmName, Farmigo.serverData.seasonTitle, Farmigo.serverData.farmWebSiteUrl);

const initialState = getStateFromStorage();
// Add the reducer to your store on the `routing` key
const store = createStore(
    reducers, initialState,
    compose(applyMiddleware(thunkMiddleware, routerMiddleware(browserHistory), crashReporter/*, deepFreezeMiddleware*/),
        window.devToolsExtension ? window.devToolsExtension() : f => f,
        useLogRocket ? LogRocket.reduxEnhancer() : f => f)
);

//Trigger for storing the state in storage
store.subscribe(() => {
    const state = store.getState();
    if (state.storage.timestamp)
        setStateInStorge(store.getState(), state.storage.timestamp);
});

// Create an enhanced history that syncs navigation events with the store
const history = syncHistoryWithStore(browserHistory, store);

// Send GA Pageviews
history.listen(location => store.dispatch(trackGAPageView(location.pathname)));
const storeUrl = "/" + URLs.STORE  + "*";
const joinUrl = "/" + URLs.JOIN  + "*";
const accountUrl = "/" + URLs.ACCOUNT  + "*";
const payUrl = "/" + URLs.PAY  + "*";
const chargeUrl = "/" + URLs.CHARGE  + "*";

ReactDOM.render((
    <Provider store={store}>
        <Router history={history}>
            <Route path={storeUrl} component={HomeScreen}/>
            <Route path={joinUrl} component={HomeScreen}/>
            <Route path={accountUrl} component={HomeScreen}/>
            <Route path={payUrl} component={HomeScreen}/>
            <Route path={chargeUrl} component={HomeScreen}/>
        </Router>
    </Provider>
), document.getElementById('root'));


// WEBPACK FOOTER //
// ./src/index.js